export default __webpack_public_path__ + "static/roadmap_mobile-8429aada6ee72bb22a4efd292ce063b3.png";